import React from "react";
import { Typography, Button } from "@arco-design/web-react";
import { IconRight } from "@arco-design/web-react/icon";
import { useHistory } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { goSWApiDocument } from "../../utils/common";
import Logo from "../Logo";

const { Title, Paragraph, Text } = Typography;

interface HeroSectionProps {
	className?: string;
	onLoginClick?: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({
	className,
	onLoginClick,
}) => {
	const { isAuthenticated } = useAuth();
	const history = useHistory();

	return (
		<section className={`hero-section ${className || ""}`}>
			<div className="hero-content">
				{/* 标签 */}
				<div className="hero-tag">
					<Text className="hero-tag-text">医疗行业 AI 开放平台</Text>
				</div>

				{/* Logo */}
				<div className="hero-logo">
					<Logo width={186} height={64} />
				</div>

				{/* 主标题 */}
				<Title heading={1} className="hero-title">
					医疗数据智能引擎
				</Title>

				{/* 副标题 */}
				<Paragraph className="hero-description">
					基于先进的大语言模型和向量搜索技术，为医疗行业提供精准的数据洞察、智能问答和开放 API 服务
				</Paragraph>

				{/* 操作按钮 */}
				<div className="hero-actions">
					{isAuthenticated ? (
						<>
							<Button
								size="large"
								type="primary"
								className="hero-button hero-button-primary"
								onClick={() => history.push("/interface-debug")}
							>
								开始使用
								<IconRight className="button-icon-right" />
							</Button>
							<Button
								size="large"
								className="hero-button hero-button-secondary"
								onClick={goSWApiDocument}
							>
								查看文档
							</Button>
						</>
					) : (
						<>
							<Button
								size="large"
								type="primary"
								className="hero-button hero-button-primary"
								onClick={onLoginClick}
							>
								立即开始
								<IconRight className="button-icon-right" />
							</Button>
							<Button
								size="large"
								className="hero-button hero-button-secondary"
								onClick={goSWApiDocument}
							>
								查看文档
							</Button>
						</>
					)}
				</div>
			</div>
		</section>
	);
};

export default HeroSection;
